import { Component, OnInit, ViewChild, HostBinding, ViewContainerRef, ApplicationRef, ElementRef, Inject } from '@angular/core';
import { Customer } from 'projects/app-misc/src/app/modules/customer/data/customer';
import { NgForm } from '@angular/forms';
import { CustomerService } from 'projects/app-misc/src/app/modules/customer/data/customer.service';
import { CustomerWindowStore } from 'projects/app-misc/src/app/modules/customer/data/customer-window.store';
import { CustomerWindowQuery } from 'projects/app-misc/src/app/modules/customer/data/customer-window.query';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';//
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { timer } from 'rxjs';
import { VendorsService } from '../../data/vendors.service';
import { Vendor } from '../../data/vendor';

@Component({
    selector: 'app-vendor-modal',
    templateUrl: './vendor-modal.component.html',
    styleUrls: ['./vendor-modal.component.scss']
})
export class VendorModalComponent implements OnInit {
    vendor: Vendor;

    header: string;

    @ViewChild('editVendorForm', { static: false })
    editVendorForm: NgForm;

    temporaryCustomer: Vendor;

    customerNumber: number;

    customerLoading: boolean;

    openThisContact: number;

    @HostBinding('class.non-active-customer')
    nonActive: boolean;

    searchQuery: string;

    constructor(
        private vendorService: VendorsService,
        protected viewContainerRef: ViewContainerRef,
        private appRef: ApplicationRef,
        protected elementRef: ElementRef,
        protected customerWindowStore: CustomerWindowStore,
        protected customerWindowQuery: CustomerWindowQuery,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {
        this.customerNumber = data.id;
    }

    ngOnInit() {
        this.getCustomer();
    }

    getCustomer() {
        this.customerLoading = true;
        this.vendorService.getVendor(this.customerNumber).subscribe(vendor => {
            this.vendor = vendor
            this.header = this.vendor.name
            this.temporaryCustomer = Object.assign({}, this.vendor)

            this.customerLoading = false;
            this.subToUpdate();
        })

    }

    subToUpdate() {
        this.appRef.tick();

        this.editVendorForm.valueChanges
            .pipe(
                debounceTime(1000),
                distinctUntilChanged()
            ).subscribe(value => {
                this.saveVendor()
            })

    }

    saveVendor() {
        this.vendorService.saveVendor(this.temporaryCustomer).subscribe()
    }
}
